module.exports = __webpack_public_path__ + "img/PPMP7.9b176ff6.png";